import Anchor from 'components/typography/anchor';
import bluesky from 'images/icons/bluesky.svg';
import facebook from 'images/icons/facebook.svg';
import google from 'images/icons/google.svg';
import linkedin from 'images/icons/linkedin.svg';
import mail from 'images/icons/mail.svg';
import tumblr from 'images/icons/tumblr.svg';
import twitter from 'images/icons/twitter.svg';
import whatsapp from 'images/icons/whatsapp.svg';
import Img from 'next/image';
import PropTypes from 'prop-types';

import config from 'siteconfig';

const ShareBlock = ({ pathname, text }) => {
  const fullUrl = new URL(pathname, config.siteUrl).href;
  const urlSafeText = encodeURIComponent(text);
  return (
    <div className="flex size-fit flex-wrap items-center rounded-sm border border-stone-200 dark:border-stone-700 print:hidden">
      <Anchor
        href={`https://bsky.app/intent/compose?text=${urlSafeText}%20%23resistbot%20${fullUrl}`}
        className="p-3.5 opacity-30 transition-opacity hover:opacity-80"
      >
        <Img
          src={bluesky}
          alt="Share on Bluesky"
          height="16"
          width="16"
          className="h-4 dark:invert"
        />
      </Anchor>
      <Anchor
        href={`https://x.com/intent/post?url=${fullUrl}&text=${urlSafeText}&related=resistbot`}
        className="p-3.5 opacity-30 transition-opacity hover:opacity-80"
      >
        <Img
          src={twitter}
          alt="Share on Twitter"
          height="16"
          width="16"
          className="h-4 dark:invert"
        />
      </Anchor>
      <Anchor
        href={`https://www.facebook.com/sharer.php?u=${fullUrl}`}
        className="p-3.5 opacity-30 transition-opacity hover:opacity-80"
      >
        <Img
          src={facebook}
          alt="Share on Facebook"
          height="16"
          width="16"
          className="h-4 dark:invert"
        />
      </Anchor>
      <Anchor
        href={`https://www.linkedin.com/shareArticle?url=${fullUrl}`}
        className="p-3.5 opacity-30 transition-opacity hover:opacity-80"
      >
        <Img
          src={linkedin}
          alt="Share on LinkedIn"
          height="16"
          width="16"
          className="h-4 dark:invert"
        />
      </Anchor>
      <Anchor
        href={`https://api.whatsapp.com/send?phone=whatsappphonenumber&text=${urlSafeText}+${fullUrl}`}
        className="p-3.5 opacity-30 transition-opacity hover:opacity-80"
      >
        <Img
          src={whatsapp}
          alt="Share on WhatsApp"
          height="16"
          width="16"
          className="h-4 dark:invert"
        />
      </Anchor>
      <Anchor
        href={`https://www.tumblr.com/widgets/share/tool?canonicalUrl=${fullUrl}&caption=${urlSafeText}`}
        className="p-3.5 opacity-30 transition-opacity hover:opacity-80"
      >
        <Img
          src={tumblr}
          alt="Share on Tumblr"
          height="16"
          width="16"
          className="h-4 dark:invert"
        />
      </Anchor>
      <Anchor
        href={`https://mail.google.com/mail/u/0/?fs=1&to&su=&body=${fullUrl}&ui=2&tf=cm`}
        className="p-3.5 opacity-30 transition-opacity hover:opacity-80"
      >
        <Img
          src={google}
          alt="Email with Gmail"
          height="16"
          width="16"
          className="h-4 dark:invert"
        />
      </Anchor>
      <Anchor
        href={`mailto:?subject=${urlSafeText}&body=${fullUrl}`}
        className="p-3.5 opacity-30 transition-opacity hover:opacity-80"
      >
        <Img
          src={mail}
          alt="Email"
          height="16"
          width="16"
          className="h-4 dark:invert"
        />
      </Anchor>
    </div>
  );
};

ShareBlock.propTypes = {
  pathname: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default ShareBlock;
